import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const FREE_IMPORT_LIMIT = 5;

export function useImportQuota(familyId: string | null) {
  const { data: used = 0, isLoading } = useQuery({
    queryKey: ["import-quota", familyId],
    queryFn: async () => {
      if (!familyId) return 0;
      const { data, error } = await supabase
        .from("school_plan_imports")
        .select("import_batch_id")
        .eq("family_id", familyId);
      if (error) throw error;
      const uniqueBatches = new Set((data || []).map((r: any) => r.import_batch_id).filter(Boolean));
      return uniqueBatches.size;
    },
    enabled: !!familyId,
  });

  return {
    used,
    limit: FREE_IMPORT_LIMIT,
    remaining: Math.max(0, FREE_IMPORT_LIMIT - used),
    isLoading,
  };
}
